define('views/modules/questionnaire/responses/response-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // collections
    'collections/questionnaire/responses',
    // views
    'views/parts/menu/menu-action',
    'views/parts/list/list',
    'views/parts/form/textbox',
    'views/modules/questionnaire/responses/response-list-item',
    'views/modules/questionnaire/responses/response-panel',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/questionnaire/responses/response-list.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // collections
    CResponses,
    // views
    VMenuAction,
    VList,
    VTextBox,
    VResponseListItem,
    VResponsePanel,
    VAlertList,
    // templates
    TResponseList
) {

    var VResponseList = Backbone.View.extend({

        template: TResponseList,

        regions: {
            root: ".results-content",
            menu: ".menu-actions",
            answered: "#answered-list",
            search: "#search-member",
            alert: '.alert-list',
        },

        initialize: function(opt) {
            opt = opt || {};

            this.group = opt.group;

            this.fullCollection = null;

            this.collection = new CResponses(null, {
                questionnaire: this.model
            });

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { route: '#', title: i18n.t('messages:tooltip-search'), icon: 'sl-icon-magnifier', toggle: true, callback: this.onSearchAction },
                    ]),
                    tooltip: {
                        container: this.regions.root,
                    },
                }),
                search: new VTextBox({ label: 'Search', attribute: 'query', model: this.queryModel }),
                answered: new VList({
                    collection: this.collection,
                    item: VResponseListItem,
                    async: false,
                }),
                alert: new VAlertList(),
            };

            this.listenTo(this.collection, { "response:click": this.onResponseClick });
            this.listenTo(this.view.search, 'submit', this.onQuerySubmit);
            this.listenTo(this.view.search, 'change', this.onChange);
            this.listenTo(this.collection, 'sync', this.onCollectionSync);
        },

        onCollectionSync: function() {
          this.fullCollection = this.collection.deepClone();
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.search, zone.$search)
                .assign(view.answered, zone.$answered)
                .assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert);

            this.collection.getFirstPage();

            return this;
        },

        ////////////
        // events //
        ////////////

        onResponseClick: function(model) {
            var view = this.view,
                panel = view.results || (view.results = new VResponsePanel({
                    questionnaire: this.model,
                    group: this.group
                }));
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onSearchAction: function(e, itemModel) {
            if (itemModel.get('active')) {
                this.zone.$search.fadeIn(300);
            } else {
                this.zone.$search.fadeOut(300);
            }
        },

        getFilteredModels: function(content) {
            return this.fullCollection.where(function(model) {
                var displayName = model.get('_user').displayName.toLowerCase();
                return displayName.indexOf(content.toLowerCase()) !== -1;
            });
        },

        addToCollection: function(models) {
            var self = this;
            models.forEach(function(model) {
                self.collection.add([model.toJSON()]);
            });
        },

        applyFilter: function(content, models) {
            this.collection.reset();

            if (!_.isEmpty(content)) this.addToCollection(models);
            else this.addToCollection(this.fullCollection.models);
        },

        onQuerySubmit: function(model) {
            this.view.alert.reset();
            var content = model.get('query');
            if (this.getFilteredModels(content).length === 0) this.view.alert.addInfo('questionnaire:questionnaire-no-results');
            this.applyFilter(content, this.getFilteredModels(content));
        },

        onChange: function(searchText) {
            if (_.isEmpty(searchText)) {
                this.view.alert.reset();
                this.applyFilter(searchText, []);
            }
        }

    });

    return VResponseList;

});

